import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenAssetReportsComponent } from "./components/loren-asset-reports/loren-asset-reports.component";
import { LorenAssetReportsRoutingModule } from "./loren-asset-reports-routing.module";
import { LorenAssetSelectionDialogModule } from "../../shared/modules/loren-asset-selection-dialog/loren-asset-selection-dialog.module";

import { LorenPeriodSelectorFormModule } from "../../shared/modules/loren-period-selector-form/loren-period-selector-form.module";
import { LorenLineChartModule } from "../../shared/modules/loren-line-chart/loren-line-chart.module";
import { LorenAssetMeteringSelectionDialogComponent } from "./components/loren-asset-reports-type-selection-dialog/loren-asset-metering-selection-dialog.component";
import { LorenDateModule } from "../../shared/pipes/loren-date/loren-date.module";
import { LorenBaseMapModule } from "../../shared/modules/loren-base-map/loren-base-map.module";
import { LorenTrackingReportComponent } from "./components/loren-tracking-report/loren-tracking-report.component";
import { LorenImageModule } from "../../shared/pipes/loren-image/loren-image.module";
import { LorenAssetResolver } from "../loren-assets/resolvers/loren-asset.resolver";
import { LorenNumericLineChartReportComponent } from "./components/loren-numeric-line-chart-report/loren-numeric-line-chart-report.component";
import { LorenPageContentComponent } from "../../shared/modules/loren-page-content/loren-page-content.component";

@NgModule({
  declarations: [
    LorenAssetReportsComponent,
    LorenAssetMeteringSelectionDialogComponent,
  ],
  providers: [LorenAssetResolver],
  imports: [
    CommonModule,
    TranslocoModule,

    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatExpansionModule,
    MatIconModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTableModule,
    
    LorenAssetReportsRoutingModule,
    LorenAssetSelectionDialogModule,
    LorenPeriodSelectorFormModule,
    LorenLineChartModule,
    LorenDateModule,
    LorenBaseMapModule,
    LorenImageModule,
    
    LorenPageContentComponent,
    LorenNumericLineChartReportComponent,
    LorenTrackingReportComponent,
  ],
})
export class LorenAssetsReportsModule {}
